import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useForm, Controller, FormProvider } from "react-hook-form";
import { Password } from "primereact/password";
import { PhoneInput } from "react-international-phone";
import { useTranslation } from "react-i18next";
import SSFRegulationsSailor from "../../../../assets/SSFRegulationsSailor.pdf";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../../../redux/actions/auth.action";
import {
  appendMandatorySignAndTimezoneText,
  UTCWithTimezoneToISOString,
  isPhoneValid,
  mergeDateTimeToServerFormat,
} from "../../../../system";
import { useNavigate } from "react-router-dom";
import BecomeVerifiedUser from "../../../../shared/components/BecomeVerifiedUser/BecomeVerifiedUser";
import ReactDatePickerWrapper from "../../../../shared/components/ReactDatePickerWrapper/ReactDatePickerWrapper";
import {
  translationConstants,
  countryConstants,
  fieldLengthConstants,
  Directions,
  globalConstants,
  preferedLanguagesContants,
  timezoneConstants,
  bloodTypes,
} from "../../../../constants";
import moment from "moment";

const RegisterationDataForm = (props) => {
  const { Mandatory_Character } = globalConstants;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedNationality, setSelectedNationality] = useState("");
  const [selectedDOBString, setSelectedDOBString] = useState(0);
  const [selectedCity, setSelectedCity] = useState("");
  const [verificationTime, setVerificationTime] = useState("");
  const countries = useSelector((state) => state.LoginReducer.countries);
  const cities = useSelector((state) => state.LoginReducer.cities);
  const methods = useForm();
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  const {
    setValue,
    getValues,
    register,
    handleSubmit,
    control,
    formState: { errors },
    trigger,
  } = methods;

  const onSubmit = async (data) => {
    const {
      firstName,
      lastName,
      firstNameArabic,
      lastNameArabic,
      email,
      phoneNumber,
      dateOfBirth,
      gender,
      password,
      nationality,
      countryresidence,
      preferredLangauge,
      verificationTime,
      documentType,
      expiredateString,
      IsUserConsented,
      nationalIdentity,
      uploadImage,
      bloodGroup,
      address,
    } = data;
    const DOBString = mergeDateTimeToServerFormat(
      dateOfBirth,
      moment().set(timezoneConstants.twelveAM).toDate()
    );
    const ExpiryData = mergeDateTimeToServerFormat(
      expiredateString,
      moment().set(timezoneConstants.twelveAM).toDate()
    );
    const RegistrationFormData = {
      EnglishFirstName: firstName,
      EnglishLastName: lastName,
      ArabicFirstName: firstNameArabic,
      ArabicLastName: lastNameArabic,
      Email: email,
      PhoneNumber: phoneNumber,
      DOBString: DOBString,
      Gender: gender,
      Password: password,
      nationality,
      CountryId: countryresidence,
      verificationTime,
      documentType: documentType ? documentType : "",
      documentExpiryDateString: ExpiryData ? ExpiryData : "",
      IsUserConsented: IsUserConsented,
      documentIdentityId: nationalIdentity,
      documents: uploadImage,
      preferredLangauge: preferredLangauge,
      bloodGroup: bloodGroup,
      address: address ? address : "",
    };
    if (!!isResidenceSaudi() && selectedCity) {
      RegistrationFormData.cityId = Number(selectedCity);
    }
    dispatch(
      authActions.registerUser(
        RegistrationFormData,
        navigate,
        props.handleShowRegSuccessModal
      )
    );
  };

  const handleVerificationTimeChange = (event) => {
    setValue("verificationTime", event.target.value, { shouldValidate: true });
    setVerificationTime(event.target.value);
  };

  useEffect(() => {
    dispatch(authActions.fetchCountries());
    // eslint-disable-next-line
  }, []);

  const isResidenceSaudi = () => {
    return (
      selectedCountry === countryConstants.SAUDIA_ARABIA && cities.length > 0
    );
  };

  return (
    <FormProvider {...methods}>
      <Form
        noValidate
        className="RegisterationDataForm"
        onSubmit={handleSubmit(onSubmit)}
      >
        <span className="welcomeSaudiPara text-center">
          {t(translationConstants.welcomePara)}
        </span>
        <span className="createAccountPara text-center">
          {t(translationConstants.createAccount)}
        </span>
        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.firstName)}:{Mandatory_Character}
            </Form.Label>
            <Form.Control
              {...register("firstName", {
                required: t(translationConstants.firstNameRequired),
                pattern: {
                  value: /^[A-Za-z\s]+$/i,
                  message: t(translationConstants.invalidFirstName),
                },
              })}
              id="firstName"
              type="text"
              maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
              placeholder={t(translationConstants.enterFirstName)}
            />
            {errors.firstName && (
              <p className="errorText">{errors.firstName.message}</p>
            )}
          </Form.Group>

          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.lastName)}:{Mandatory_Character}
            </Form.Label>
            <Form.Control
              {...register("lastName", {
                required: t(translationConstants.lastNameRequired),
                pattern: {
                  value: /^[A-Za-z\s]+$/i,
                  message: t(translationConstants.invalidLastName),
                },
              })}
              id="lastName"
              type="text"
              maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
              placeholder={t(translationConstants.enterLastName)}
            />
            {errors.lastName && (
              <p className="errorText">{errors.lastName.message}</p>
            )}
          </Form.Group>
        </div>

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.firstNameArabic)}:{" "}
              <span>{t(translationConstants.optional)}</span>{" "}
            </Form.Label>
            <Form.Control
              {...register("firstNameArabic", {
                // ... your existing rules
              })}
              id="firstNameArabic"
              type="text"
              maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
              placeholder="محمد"
              style={{ direction: Directions.rtl }}
            />
            {errors.firstNameArabic && (
              <p className="errorText">{errors.firstNameArabic.message}</p>
            )}
          </Form.Group>

          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.lastNameArabic)}:{" "}
              <span>{t(translationConstants.optional)}</span>
            </Form.Label>
            <Form.Control
              {...register("lastNameArabic", {})}
              id="lastNameArabic"
              type="text"
              maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
              placeholder="احمد"
              style={{ direction: Directions.rtl }}
            />
            {errors.lastNameArabic && (
              <p className="errorText">{errors.lastNameArabic.message}</p>
            )}
          </Form.Group>
        </div>

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.email) + ":" + Mandatory_Character}
            </Form.Label>
            <Form.Control
              {...register("email", {
                required: t(translationConstants.emailRequired),
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/i,
                  message: t(translationConstants.invalidEmail),
                },
              })}
              id="email"
              type="email"
              maxLength={fieldLengthConstants.EMAIL_FIELD_LENGTH}
              placeholder="Ex: abc@example.com"
            />
            {errors.email && (
              <p className="errorText">{errors.email.message}</p>
            )}
          </Form.Group>

          <Form.Group className="">
            <Form.Label className="Form-labels">
              {t(translationConstants.phoneNumber)}:{Mandatory_Character}
            </Form.Label>
            <Controller
              name="phoneNumber"
              control={control}
              rules={{
                required: t(translationConstants.phoneNumberRequired),
                validate: (value) => {
                  const isValid = isPhoneValid(value);
                  if (!isValid) {
                    return t(translationConstants.enterValidPhoneNumber);
                  }
                  return true;
                },
              }}
              render={({ field: { onChange, value } }) => (
                <PhoneInput
                  id="phone-number-registration"
                  defaultCountry="sa"
                  value={value}
                  onChange={onChange}
                  maxLength={fieldLengthConstants.PHONENUMBER_FIELD_LENGTH}
                />
              )}
            />

            {errors.phoneNumber && (
              <p className="errorText">{errors.phoneNumber.message}</p>
            )}
          </Form.Group>
        </div>

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {appendMandatorySignAndTimezoneText(
                t(translationConstants.dateOfBirth),
                t
              )}
            </Form.Label>
            <Controller
              name="dateOfBirth"
              control={control}
              rules={{ required: t(translationConstants.dateOfBirthRequired) }}
              render={({ field }) => (
                <ReactDatePickerWrapper
                  onChange={(date) => {
                    field.onChange(date);
                    setSelectedDOBString(
                      mergeDateTimeToServerFormat(
                        date,
                        moment().set(timezoneConstants.twelveAM).toDate()
                      )
                    );
                  }}
                  selected={field.value}
                  maxDate={new Date(UTCWithTimezoneToISOString())}
                  value={field.value}
                />
              )}
            />
            {errors.dateOfBirth && (
              <p className="errorText">{errors.dateOfBirth.message}</p>
            )}
          </Form.Group>

          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.gender)}:{Mandatory_Character}
            </Form.Label>
            <Form.Select
              className="custom-select-icon"
              {...register("gender", {
                required: t(translationConstants.genderSelectionRequired),
              })}
              aria-label="Default select example"
            >
              <option value="">{t(translationConstants.selectGender)}</option>
              <option value={0}>{t(translationConstants.male)}</option>
              <option value={1}>{t(translationConstants.female)}</option>
            </Form.Select>
            {errors.gender && (
              <p className="errorText">{errors.gender.message}</p>
            )}
          </Form.Group>
        </div>

        <div className="inputRow">
          <Form.Group className="form-group-register registrationPassword">
            <Form.Label className="Form-labels">
              {t(translationConstants.createPassword)}:{Mandatory_Character}
            </Form.Label>
            <Controller
              name="password"
              control={control}
              rules={{
                required: t(translationConstants.passwordRequired),
                pattern: {
                  value:
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                  message: t(translationConstants.passwordRequirements),
                },
              }}
              render={({ field }) => (
                <Password {...field} toggleMask feedback={false} />
              )}
            />
            {errors.password && (
              <p className="errorText">{errors.password.message}</p>
            )}
          </Form.Group>

          <Form.Group className="form-group-register registrationPassword">
            <Form.Label className="Form-labels">
              {t(translationConstants.confirmPassword)}:{Mandatory_Character}
            </Form.Label>
            <Controller
              name="confirmPassword"
              control={control}
              rules={{
                required: t(translationConstants.confirmPasswordRequired),
                validate: (value) =>
                  value === getValues("password") ||
                  t(translationConstants.passwordsDoNotMatch),
              }}
              render={({ field }) => (
                <Password {...field} toggleMask feedback={false} />
              )}
            />
            {errors.confirmPassword && (
              <p className="errorText">{errors.confirmPassword.message}</p>
            )}
          </Form.Group>
        </div>

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.ADDRESS)}:
            </Form.Label>
            <Form.Control
              type="text"
              id="address"
              placeholder={t(translationConstants.ENTER_ADDRESS)}
              {...register("address", {})}
            />
            {errors?.address && (
              <p className="errorText">{errors?.address.message}</p>
            )}
          </Form.Group>

          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.nationality)}:{Mandatory_Character}
            </Form.Label>
            <Form.Select
              className="custom-select-icon"
              {...register("nationality", {
                required: t(translationConstants.nationalityRequired),
              })}
              aria-label="Default select example"
              onChange={({ target: { value } }) =>
                setSelectedNationality(value)
              }
            >
              <option value="">
                {t(translationConstants.selectnationality)}
              </option>
              {countries?.data?.map((data) => (
                <option key={data.id} value={data.nationality}>
                  {direction === Directions.rtl
                    ? data.arabicNationality
                    : data.nationality}
                </option>
              ))}
            </Form.Select>
            {errors.nationality && (
              <p className="errorText">{errors.nationality.message}</p>
            )}
          </Form.Group>
        </div>

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.countryOfResidence)}:{Mandatory_Character}
            </Form.Label>
            <Form.Select
              className="custom-select-icon"
              {...register("countryresidence", {
                required: t(translationConstants.countryResidenceRequired),
              })}
              onChange={(e) => {
                const value = e.target.value;
                setValue("countryresidence", value, { shouldValidate: true });
                setSelectedCountry(value);
                value && dispatch(authActions.fetchCities(value));
                trigger("countryresidence"); // Trigger validation for the 'countryresidence' field
                e.stopPropagation();
              }}
              value={selectedCountry}
              aria-label="Default select example"
            >
              <option value="">
                {t(translationConstants.selectresidence)}
              </option>
              {countries?.data?.map((residence) => (
                <option key={residence.id} value={residence.id}>
                  {direction === Directions.rtl
                    ? residence.arabicName
                    : residence.name}
                </option>
              ))}
            </Form.Select>

            {errors.countryresidence && (
              <p className="errorText">{errors.countryresidence.message}</p>
            )}
          </Form.Group>

          {!!isResidenceSaudi() && (
            <Form.Group className="form-group-register">
              <Form.Label htmlFor="cityResidenceSelect" className="Form-labels">
                {t(translationConstants.cityofresidence)}:{Mandatory_Character}
              </Form.Label>
              <Form.Select
                id="cityResidenceSelect"
                {...register("cityresidence", {
                  required: t(translationConstants.cityResidenceRequired),
                })}
                onChange={(e) => {
                  const value = e.target.value;
                  setValue("cityresidence", value, { shouldValidate: true });
                  setSelectedCity(value);
                  trigger("cityresidence"); // Trigger validation for the 'countryresidence' field
                  e.stopPropagation();
                }}
                aria-label="Default select example"
              >
                <option value="">{t(translationConstants.selectcity)}</option>
                {cities?.map((city) => (
                  <option key={city.id} value={city.id}>
                    {direction === Directions.rtl ? city.arabicName : city.name}
                  </option>
                ))}
              </Form.Select>
              {errors.cityresidence && (
                <p className="errorText">{errors.cityresidence.message}</p>
              )}
            </Form.Group>
          )}

          <Form.Group
            className={`form-group-register ${
              !!isResidenceSaudi() ? "mt-3" : ""
            }`}
          >
            <Form.Label
              htmlFor="preferredLanguageSelect"
              className="Form-labels"
            >
              {t(translationConstants.PREFERRED_LANGUAGE)}:{Mandatory_Character}
            </Form.Label>
            <Form.Select
              id="preferredLanguageSelect"
              {...register("preferredLangauge", {
                required: t(
                  translationConstants.SELECT_PREFERRED_LANGUAGE_Required
                ),
              })}
              onChange={(e) => {
                const value = e.target.value;
                setValue("preferredLangauge", value, { shouldValidate: true });
                trigger("preferredLangauge"); // Trigger validation for the 'countryresidence' field
                e.stopPropagation();
              }}
              aria-label="Default select example"
            >
              <option value="">
                {t(translationConstants.SELECT_PREFERRED_LANGUAGE)}
              </option>
              <option value="0">{preferedLanguagesContants.Arabic}</option>
              <option value="1">{preferedLanguagesContants.English}</option>
            </Form.Select>
            {errors.preferredLangauge && (
              <p className="errorText">{errors.preferredLangauge.message}</p>
            )}
          </Form.Group>

          <Form.Group className="form-group-register mt-3">
            <Form.Label className="Form-labels">
              {t(translationConstants.BLOOD_GROUP)}:{Mandatory_Character}
            </Form.Label>
            <Form.Select
              className="custom-select-icon"
              {...register("bloodGroup", {
                required: t(translationConstants.BLOOD_GROUP_REQUIRED),
              })}
            >
              <option value="">
                {t(translationConstants.SELECT_BLOOD_GROUP)}
              </option>
              {Object.values(bloodTypes).map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </Form.Select>
            {errors.bloodGroup && (
              <p className="errorText">{errors.bloodGroup.message}</p>
            )}
          </Form.Group>
        </div>

        <div className="inputRow"></div>

        <div className="align-items-center registrationCheckBoxs">
          <p className="uploadPara">
            {t(translationConstants.uploadDocuments)}:{Mandatory_Character}
          </p>
          <Form.Group>
            <div className="d-flex radio-button">
              <Form.Check
                inline
                label={t(translationConstants.verificationTimeNow)}
                value="now"
                type="radio"
                id="inline-radio-1"
                {...register("verificationTime", {
                  required: t(translationConstants.verificationTimeRequired),
                })}
                onChange={handleVerificationTimeChange}
              />
              <Form.Check
                inline
                label={t(translationConstants.verificationTimeLater)}
                value="later"
                type="radio"
                id="inline-radio-2"
                defaultChecked={true}
                {...register("verificationTime", {
                  required: t(translationConstants.verificationTimeRequired),
                })}
                onChange={handleVerificationTimeChange}
              />
            </div>
            {errors.verificationTime && (
              <p className="errorText">{errors.verificationTime.message}</p>
            )}
          </Form.Group>
        </div>

        {/* verified User Form */}

        {verificationTime === "now" && (
          <div className="registrationCheckBoxs varifiedDocumentDiv">
            <BecomeVerifiedUser
              dobString={selectedDOBString}
              countryId={selectedNationality}
            />
          </div>
        )}
        <Form.Group
          className="d-flex align-items-center justify-content-space-between registrationCheckBoxs"
          controlId="formBasicCheckbox"
        >
          <Form.Check
            className="custom-checkbox m-0"
            type="checkbox"
            label={<p>{t(translationConstants.agreeToTerms)}&nbsp;</p>}
            {...register("IsUserConsented", {
              required: t(translationConstants.IsUserConsented),
            })}
          />
          <span
            onClick={() => window.open(SSFRegulationsSailor)}
            className="ssf-regulations-label theme-text-color"
          >
            {`${t(translationConstants.SSFRegulations)}.`}
          </span>{" "}
          {errors.IsUserConsented && (
            <p className="errorText">{errors.IsUserConsented.message}</p>
          )}
        </Form.Group>
        <Button className="Registeration-button" type="submit">
          {t(translationConstants.registerButton)}
        </Button>
      </Form>
    </FormProvider>
  );
};

export default RegisterationDataForm;
